import React from 'react';

function SelectArrowIcon({ className }) {
	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='11'
			height='6'
			fill='none'
			viewBox='0 0 11 6'
		>
			<g clipPath='url(#clip0_10_695)'>
				<path
					stroke='#B9B9B9'
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth='1.5'
					d='M9.75.75s-3.314 4.5-4.5 4.5S.75.75.75.75'
				></path>
			</g>
			<defs>
				<clipPath id='clip0_10_695'>
					<path fill='#fff' d='M0 0H10.5V6H0z'></path>
				</clipPath>
			</defs>
		</svg>
	);
}

export default SelectArrowIcon;
